import { render, staticRenderFns } from "./ZoneBind.vue?vue&type=template&id=23cfedbd&scoped=true&"
import script from "./ZoneBind.vue?vue&type=script&lang=js&"
export * from "./ZoneBind.vue?vue&type=script&lang=js&"
import style0 from "./ZoneBind.vue?vue&type=style&index=0&id=23cfedbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cfedbd",
  null
  
)

export default component.exports